export const statesParse = {
  'Selecione': 'Selecione',
  'AC': 'Acre',
  'AL': 'Alagoas',
  'AP': 'Amapá',
  'AM': 'Amazonas',
  'BA': 'Bahia',
  'CE': 'Ceará',
  'ES': 'Espírito Santo',
  'GO': 'Goiás',
  'MA': 'Maranhão',
  'MT': 'Mato Grosso',
  'MS': 'Mato Grosso do Sul',
  'MG': 'Minas Gerais',
  'PA': 'Pará',
  'PB': 'Paraíba',
  'PR': 'Paraná',
  'PE': 'Pernambuco',
  'PI': 'Piauí',
  'RJ': 'Rio de Janeiro',
  'RN': 'Rio Grande do Norte',
  'RS': 'Rio Grande do Sul',
  'RO': 'Rondônia',
  'RR': 'Roraima',
  'SC': 'Santa Catarina',
  'SP': 'São Paulo',
  'SE': 'Sergipe',
  'TO': 'Tocantins',
  'DF': 'Distrito Federal',
}

export const states = [
  {
    label: 'Selecione',
    sigla: 'Selecione'
  },
  {
    label: 'Acre',
    sigla: 'AC'
  },
   {
    label: 'Alagoas',
    sigla: 'AL'
  },
   {
    label: 'Amapá',
    sigla: 'AP'
  },
  {
    label: 'Amazonas',
    sigla: 'AM'
  },
  {
    label: 'Bahia',
    sigla: 'BA'
  },
  {
    label: 'Ceará',
    sigla: 'CE'
  },
  {
    label: 'Espírito Santo',
    sigla: 'ES'
  },
  {
    label: 'Goiás',
    sigla: 'GO'
  },
  {
    label: 'Maranhão',
    sigla: 'MA'
  },
  {
    label: 'Mato Grosso',
    sigla: 'MT'
  },
  {
    label: 'Mato Grosso do Sul',
    sigla: 'MS'
  },
  {
    label: 'Minas Gerais',
    sigla: 'MG'
  },
  {
    label: 'Pará',
    sigla: 'PA'
  },
  {
    label: 'Paraíba',
    sigla: 'PB'
  },
  {
    label: 'Paraná',
    sigla: 'PR'
  },
  {
    label: 'Pernambuco',
    sigla: 'PE'
  },
  {
    label: 'Piauí',
    sigla: 'PI'
  },
  {
    label: 'Rio de Janeiro',
    sigla: 'RJ'
  },
  {
    label: 'Rio Grande do Norte',
    sigla: 'RN'
  },
  {
    label: 'Rio Grande do Sul',
    sigla: 'RS'
  },
  {
    label: 'Rondônia',
    sigla: 'RO'
  },
  {
    label: 'Roraima',
    sigla: 'RR'
  },
  {
    label: 'Santa Catarina',
    sigla: 'SC'
  },
  {
    label: 'São Paulo',
    sigla: 'SP'
  },
  {
    label: 'Sergipe',
    sigla: 'SE'
  },
  {
    label: 'Tocantins',
    sigla: 'TO'
  },
  {
    label: 'Distrito Federal',
    sigla: 'DF'
  },
]